<template>
  <div>
  <router-view></router-view>
</div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  name: 'Auth',
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {

  },
  created() {

  }
}

</script>
<style></style>



// WEBPACK FOOTER //
// src/Auth/containers/Auth.vue